import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, shareReplay } from 'rxjs';
import { Windward } from '../models/windward';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WindwardService {
  constructor(private http: HttpClient) {}

  private mapLinks$ = new Map<string, Observable<Windward[]>>();

  getMapLinksFor(shipmentNumber: string) {
    if (!this.mapLinks$.has(shipmentNumber)) {
      this.mapLinks$.set(
        shipmentNumber,
        this.http.get<{ value: Windward[] }>(`${environment.apiUrl}/shipments/${shipmentNumber}/windwardMapLinks`).pipe(
          map(({ value }) => value || []),
          shareReplay()
        )
      );
    }

    return this.mapLinks$.get(shipmentNumber)!;
  }
}
